module.exports = __webpack_public_path__ + "static/media/group-users.2bce7f49.svg";